module.exports = __webpack_public_path__ + "static/media/hurricane.cde6e377.png";